import { Button } from "@/atoms";
import { strings } from "@/constants";
import { ButtonVariantEnum } from "@/enums";

export const CompanyDetailActions = ({
    isDeleting,
    isEnabled,
    isToggling,
    onDelete,
    onToggle,
}: {
    isDeleting: boolean,
    isEnabled: boolean,
    isToggling: boolean,
    onDelete: () => void,
    onToggle: () => void,
}) => {
    const isBusy = isToggling || isDeleting;

    return (
        <div
            className="
                flex
                flex-col
                gap-3
                border-t
                border-gray-200
                bg-gray-50
                px-4
                py-3
                sm:flex-row
                sm:items-center
                sm:justify-end
                sm:px-6
                sm:py-4
            "
        >
            <Button
                disabled={isBusy}
                isLoading={isToggling}
                variant={ButtonVariantEnum.MUTED}
                onClick={onToggle}
            >
                {isEnabled ? strings.admin.disableCompany : strings.admin.enableCompany}
            </Button>
            <Button
                disabled={isBusy}
                isLoading={isDeleting}
                variant={ButtonVariantEnum.DANGER}
                onClick={onDelete}
            >
                {strings.admin.deleteCompany}
            </Button>
        </div>
    );
};
